
import Visual1 from "../../../img/screenshots/travelagents/travelagent-feature-01.png";
import Visual2 from "../../../img/screenshots/travelagents/travelagent-feature-02.png";
import Visual3 from "../../../img/screenshots/travelagents/travelagent-feature-03.png";
import Visual4 from "../../../img/screenshots/travelagents/travelagent-feature-04.png";



export const TravelAgentFeaturesContent = [
    { 
      title:"Turn Clients into brand ambassadors",     
      subtitle:"Enable clients to easily share their plan",      
      text:"Stippl helps tour operators create beautiful itineraries that turn clients into brand ambassadors by providing a great experience. Clients can easily promote the tour operator's brand through the app by sharing their itinerary and experiences with friends and family.",
      image:Visual1
    },
    { 
      title:"Empower clients with the travel tools they need",     
      subtitle:"Be there during travel, not just before",      
      text:"Stippl helps your clients with planning during travel, providing budgeting, recommendations, and packing list features. These features help clients stay within budget, make the trip more enjoyable, and help tour operators build a reputation for providing well-organised and memorable trips.",
      image:Visual2
    },
    { 
      title:"Increase bookings through your clients’ social networks",     
      subtitle:"Trips on social media",      
      text:"Stippl, helps tour operators attract more clients by providing digital itineraries that can be easily shared on social media. Clients can showcase their experiences and promote the tour operator's brand to their friends and family, which helps to increase bookings and build a reputation for providing memorable trips.",
      image:Visual3
    },
    { 
      title:"Create beautiful & inspiring itineraries with ease",     
      subtitle:"Interactive & shareable itineraries",      
      text:"Stippl, makes it easy for tour operators to create beautiful itineraries with its trip builder feature. Search, click and reorder destinations to create visually appealing and detailed itineraries that showcase all of the highlights and experiences of the tours. This can help to entice potential clients.",
      image:Visual4
    }
  ]